import { axiosInstance } from '@refinedev/simple-rest';

export async function getAuthorizedFileURL(src: string) {
  const url = new URL(src, window.location.origin);

  if (
    (url.protocol === 'https:' || url.protocol === 'http:') &&
    url.origin === window.location.origin &&
    url.pathname.startsWith('/.api/')
  ) {
    // axiosInstanceにはヘッダーに認可トークンがセットされている
    const res = await axiosInstance.get(src, { responseType: 'blob' });
    return URL.createObjectURL(res.data);
  } else {
    // e.g. `blob:`
    return src;
  }
}

export async function getAuthorizedFile(src: string): Promise<File> {
  const res = await axiosInstance.get(src, { responseType: 'blob' });
  return res.data;
}
